
export const useDB = () => {


    const getEvent = async ( eventID ) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/events/${eventID}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error fetching Assessments:", error);
            throw error;
        }
    };


    const getEvents = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/events`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error fetching Assessments:", error);
            throw error;
        }
    };

    const getPictures = async (  eventID ) => {
        console.log(`Event ID: ${eventID}`);
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/events/${eventID}/pictures`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error fetching Assessments:", error);
            throw error;
        }
    };

    const enableEvent = async (  eventID ) => {

        try {
            const response =  await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/settings/enableEvent/${eventID}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error fetching Assessments:", error);
            throw error;
        }
    };

    const deleteEvent = async (  eventID ) => {

        try {
            const response =  await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/events/${eventID}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error fetching Assessments:", error);
            throw error;
        }
    };

    const updateEvent = async (event) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/events/${event["_id"]}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(event), // Send the event object as the request body
            });
            console.log("PUT:::", JSON.stringify(event));

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error updating event:", error);
            throw error;
        }
    };



    const getSettings = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/settings`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error fetching Assessments:", error);
            throw error;
        }
    };



    const getFolders = async (eventID) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/folders/event/${eventID}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error fetching folders:", error);
            throw error;
        }
    };

    const createFolder = async (eventID, name) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/folders`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ eventId: eventID, name }),
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error creating folder:", error);
            throw error;
        }
    };

    const updateFolder = async (folderID, changes) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/folders/${folderID}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(changes),
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error updating folder:", error);
            throw error;
        }
    };

    const deleteFolder = async (folderID) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/folders/${folderID}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) return false;
            return await response.json();
        } catch (error) {
            console.error("Error deleting folder:", error);
            throw error;
        }
    };

    return {
        getEvents,
        enableEvent,
        deleteEvent,
        updateEvent,
        getEvent,
        getSettings,
        getPictures,
        getFolders,
        createFolder,
        updateFolder,
        deleteFolder
    };
};